import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=51915eb2&scoped=true"
import script from "./distribution.vue?vue&type=script&lang=js"
export * from "./distribution.vue?vue&type=script&lang=js"
import style0 from "./distribution.vue?vue&type=style&index=0&id=51915eb2&prod&lang=scss"
import style1 from "./distribution.vue?vue&type=style&index=1&id=51915eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51915eb2",
  null
  
)

export default component.exports